import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import Vue from 'vue'

NProgress.configure({ showSpinner: false })// NProgress Configuration  禁用进度条

/**
 * 登录拦截白名单
 * @type {string[]}
 */
const whiteList = ['/login', '/auth-redirect']// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (Vue.prototype.MerchantHost.indexOf(document.domain) > -1) {
    document.title = 'cocopay商户管理系统'
  } else if (Vue.prototype.ManageHost.indexOf(document.domain) > -1) {
    document.title = 'cocopay总管理系统'
  } else if (Vue.prototype.AgentHost.indexOf(document.domain) > -1) {
    document.title = 'cocopay代理系统'
  }
  if (localStorage.getItem('userInfo')) { // determine if there has token      getToken()
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      // router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
      // next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
      if (!store.state.addRoles) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GenerateRoutes').then(() => { // 根据roles权限生成可访问的路由表
          router.addRoutes(store.state.addRouters) // 动态添加可访问路由表
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        })
      } else {
        // 此处要判断是否有添加过路由 todo
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js